import { useEffect } from "react";

// The global sticky set
const stickyList = new Set();

// Calculates the offset all the sticky elements occupy
const getStickyListHeight = () => {
  let height = 0;
  for (let item of stickyList) {
    height += item.offsetHeight;
  }
  return height;
};

// Makes the passed component sticky if sticky is true
export const useSticky = (ref, sticky, styles = {}) => {
  useEffect(() => {
    const handler = window.addEventListener("scroll", () => {
      if (sticky && ref && ref.current) {
        const { current } = ref;
        const { offsetTop, style, classList } = current;
        const { pageYOffset } = window;

        const reached = pageYOffset > 50 && pageYOffset > offsetTop;
        const isSticky = stickyList.has(current);

        if (reached) {
          if (!isSticky) {
            const offset = getStickyListHeight();
            const index = 1000 - stickyList.size;

            style.setProperty("--top", `${offset}px`);
            style.setProperty("z-index", index);
            Object.keys(styles).forEach(function(key) {
              style.setProperty(key, styles[key]);
            });
            classList.add("sticky-component");
            stickyList.add(current);
          }
        } else if (isSticky) {
          classList.remove("sticky-component");
          stickyList.delete(current);
        }
      }
    });

    return () => {
      stickyList.delete(ref.current);
      window.removeEventListener("scroll", handler);
    };
  }, [sticky]);
};
